import { useQueryVariables } from 'hooks';
import { SpecialProjectsPropsFragment } from 'schema/serverTypes';
import { StateConfig } from 'hooks/useQueryVariables/types';

export const useSpecialProjectsQueryVariables = (
  config: StateConfig<SpecialProjectsPropsFragment, any>
) => {
  const queryVariables = useQueryVariables<SpecialProjectsPropsFragment>(config);

  return {
    ...queryVariables,
    onSpecialProjectsFilterChange: queryVariables.onFilterChange,
  };
};
